import { BubbleMenu, BubbleMenuProps, useCurrentEditor } from '@tiptap/react';
import { PropsWithChildren } from 'react';

interface FloatingMenuProps {
  // NOTE: this is needed for multiple bubble menus
  name?: string;
  shouldShow?: BubbleMenuProps['shouldShow'];
}

export default function FloatingMenu({
  name = 'FloatingMenu',
  shouldShow,
  children,
}: PropsWithChildren<FloatingMenuProps>) {
  const { editor } = useCurrentEditor();
  if (!editor) return null;
  return (
    <BubbleMenu
      pluginKey={name}
      shouldShow={shouldShow}
      editor={editor}
      tippyOptions={{ duration: 100 }}
    >
      <div className="flex border-solid border-neutral-300 border bg-neutral-100 rounded-md shadow">
        {children}
      </div>
    </BubbleMenu>
  );
}
